/*🤫*/
/*🤫*/
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
class Breakpoint {
    /*🤫
🤫
🤫
🤫*/
    constructor(breakpoints) {
        this.breakpoints = breakpoints;
    }
    /*🤫
🤫
🤫
🤫
🤫*/
    getBreakpoints() {
        return this.breakpoints;
    }
    /*🤫
🤫
🤫
🤫
🤫*/
    isSmall() {
        return this.breakpoints.small.matches;
    }
    /*🤫
🤫
🤫
🤫
🤫*/
    isMedium() {
        return this.breakpoints.medium.matches;
    }
    /*🤫
🤫
🤫
🤫
🤫*/
    isLarge() {
        return this.breakpoints.large.matches;
    }
    /*🤫
🤫
🤫
🤫
🤫*/
    isExtraLarge() {
        return this.breakpoints.extraLarge.matches;
    }
    /*🤫
🤫
🤫
🤫
🤫*/
    getCurrentBreakpoint() {
        let result = "unknown";
        if (this.isSmall()) {
            result = "s";
        }
        else if (this.isMedium()) {
            result = "m";
        }
        else if (this.isLarge()) {
            result = "l";
        }
        else if (this.isExtraLarge()) {
            result = "xl";
        }
        return result;
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫*/
    isBreakpointActive(breakpointList) {
        const currentBreakpoint = this.getCurrentBreakpoint();
        /*🤫*/
        for (let i = 0; i < breakpointList.length; i++) {
            if (breakpointList[i] === currentBreakpoint) {
                return true;
            }
        }
        return false;
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    registerChangeListener(callback) {
        const listenerWrapper = {
            trigger(bPoint) {
                /*🤫*/
                return function breakpointListener(breakpoints) {
                    if (breakpoints.matches) {
                        callback(bPoint);
                    }
                };
            },
        };
        if (this.breakpoints.small.addEventListener) {
            this.breakpoints.small.addEventListener("change", listenerWrapper.trigger("s"));
            this.breakpoints.medium.addEventListener("change", listenerWrapper.trigger("m"));
            this.breakpoints.large.addEventListener("change", listenerWrapper.trigger("l"));
            this.breakpoints.extraLarge.addEventListener("change", listenerWrapper.trigger("xl"));
        }
        else {
            /*🤫*/
            /*🤫*/
            this.breakpoints.small.addListener(listenerWrapper.trigger("s"));
            this.breakpoints.medium.addListener(listenerWrapper.trigger("m"));
            this.breakpoints.large.addListener(listenerWrapper.trigger("l"));
            this.breakpoints.extraLarge.addListener(listenerWrapper.trigger("xl"));
        }
    }
}
/*🤫
🤫
🤫
🤫*/
function breakpoint() {
    return new Breakpoint({
        small: window.matchMedia("(min-width: 0em) and (max-width: 27.99em)"),
        medium: window.matchMedia("(min-width: 28em) and (max-width: 47.99em)"),
        large: window.matchMedia("(min-width: 48em) and (max-width: 61.99em)"),
        extraLarge: window.matchMedia("(min-width: 62em)"),
    });
}

export { Breakpoint, breakpoint };
